import { IGfpOffer, IGfpOfferParams } from 'types/api/GfpOffer';
import paramsSerializer from 'utils/paramsSerializer';
import { AxiosResponse } from 'axios';
import baseApi from './config';

export async function getGfpOffers(
  params: IGfpOfferParams,
  lkpOfferId: number,
): Promise<AxiosResponse<IGfpOffer[]>> {
  return baseApi.get(`api/offer/by-gfp/${lkpOfferId}`, {
    params,
    paramsSerializer,
  });
}
